(function () {
  window.addEventListener('DOMContentLoaded', () => {
    const View = {
      historyProducts: document.getElementById('history-products'),
      historyProductsShimmer: document.getElementById(
        'history-products-shimmer'
      ),
      seeMoreButton: (() => {
        const html = `<a class="c-btn" href="/pages/recently-visited">すべての閲覧履歴をみる</a>`;
        const div = document.createElement('div');
        div.innerHTML = html;

        return div.firstChild;
      })(),
    };

    const Controller = {
      /**
       * @param {Product[]} data
       * @returns
       */
      getProductListDOM(data) {
        const arrLength = data.length;

        let htmlRow = `<div class="grid product-list-container grid--2-col grid--4-col-tablet grid--5-col-desktop">`;
        for (let j = 0; j < arrLength; j++) {
          htmlRow += _Components.productCard(data[j]);
        }

        htmlRow += `</div>`;
        const div = document.createElement('div');
        div.innerHTML = htmlRow;

        return div.firstChild;
      },
    };

    try {
      window._Services?.viewingHistory
        ?.getHistoryItems()
        .then((res) => {
          if (!res || res.length == 0) {
            throw new Error();
          }

          View.historyProducts.appendChild(
            Controller.getProductListDOM(res.slice(0, 10))
          );

          if (res.length > 10) {
            View.historyProducts.appendChild(View.seeMoreButton);
          }
        })
        .then(() => {
          window?._Services?.favourite?.renderFavForCards();
        })
        .catch((e) => {
          console.log({ e });
          View.historyProducts.innerHTML = `
          <div class="section-collection__no-product">
            商品の閲覧履歴はありません。
          </div>
        `;
        })
        .finally(() => {
          View.historyProductsShimmer.style.display = 'none';
        });
    } catch (e) {
      View.historyProductsShimmer.style.display = 'none';
    }
  });
})();
